import React from 'react';
import type { DeskSlots, PageBodyProps, PageHeaderProps } from '@valutten/partner-desk-ui';

/**
 * The desk's page chrome inside Partner Referrals. The page already carries
 * the app's PageHeader ("Partner Referrals"), so each desk screen's header is
 * a section heading inside the desk panel, and the body adds no padding of its
 * own (AppLayout's <main> provides the only page padding).
 */
const DeskSectionHeader: React.FC<PageHeaderProps> = ({ title, sub, actions }) => (
  <div className="flex flex-wrap items-end gap-3 pb-4">
    <div className="min-w-0">
      <h3 className="text-xl font-semibold tracking-tight text-on-surface">{title}</h3>
      {sub && <div className="mt-0.5 text-sm text-on-surface-variant">{sub}</div>}
    </div>
    {actions && <div className="ml-auto flex flex-wrap gap-2">{actions}</div>}
  </div>
);

const DeskSectionBody: React.FC<PageBodyProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

export const DESK_SLOTS: DeskSlots = { PageHeader: DeskSectionHeader, PageBody: DeskSectionBody };
